import React from 'react';
import { Music } from 'lucide-react';
import { MusicLiveDemo } from './MusicLiveDemo';

// Alturas fixas simulando um equalizador — puramente decorativo no fundo da seção.
const BAR_HEIGHTS = [30, 55, 40, 70, 45, 90, 35, 60, 50, 75, 40, 65, 30, 80, 45, 55, 35, 70, 50, 40, 32, 58, 42, 68];

/**
 * Seção própria para Música Terapêutica (antes um card dentro de um grid
 * genérico). Fundo com barras de equalizador desfocadas na base — identidade
 * sonora específica desta seção.
 */
const MusicSpotlightSection = () => {
  return (
    <section className="relative py-20 md:py-28 bg-muted/30 overflow-hidden">
      <div
        className="absolute bottom-0 inset-x-0 h-36 flex items-end justify-center gap-2 opacity-[0.18] dark:opacity-[0.14] blur-[2px] pointer-events-none"
        aria-hidden="true"
      >
        {BAR_HEIGHTS.map((h, i) => (
          <span key={i} className="w-3 rounded-t-full bg-primary flex-shrink-0" style={{ height: `${h}%` }} />
        ))}
      </div>
      <div className="absolute inset-0 flex items-center justify-center pointer-events-none" aria-hidden="true">
        <div
          className="w-[340px] h-[340px] rounded-full opacity-30 blur-3xl"
          style={{ background: 'radial-gradient(circle, rgb(var(--primary)) 0%, transparent 70%)' }}
        />
      </div>

      <div className="relative container mx-auto px-6 text-center">
        <div className="inline-flex items-center gap-2 bg-primary/10 dark:bg-primary/15 px-3 py-1.5 rounded-full text-sm font-semibold text-foreground mb-5">
          <Music className="w-4 h-4 text-primary-ink dark:text-primary-tint" />
          Música Terapêutica
        </div>
        <h2 className="text-4xl md:text-5xl font-bold text-foreground">
          Relaxar e se concentrar com <span className="text-primary-ink dark:text-primary-tint">música</span>
        </h2>
        <p className="font-body text-lg text-muted-foreground mt-4 max-w-xl mx-auto">
          Composições com IA voltadas ao relaxamento, foco e bem-estar.
        </p>

        <div className="relative mt-12 max-w-sm mx-auto">
          <MusicLiveDemo />
        </div>
      </div>
    </section>
  );
};

export default MusicSpotlightSection;
